import ArrowIcon from 'components/common/ArrowIcon';
import SectionContainer from 'components/common/SectionContainer';
import useLocaleLink from 'hooks/useLocaleLink';
import { useTranslations } from 'next-intl';
import type { AnnouncementCategory } from 'types/help-center';

interface AnnouncementSectionProps {
  categories: AnnouncementCategory[];
}

export default function AnnouncementSection({ categories }: AnnouncementSectionProps) {
  const t = useTranslations('support');
  const localeLink = useLocaleLink();

  return (
    <SectionContainer>
      <h2 className="mb-4 text-[22px] font-bold text-base-label pad:mb-10 pad:text-5xl">{t('announcementCenter')}</h2>

      <div className="flex flex-col gap-4 pad:grid pad:grid-cols-2 pad:gap-4 pc-small:grid-cols-3">
        {categories.map((cat) => (
          <a
            key={cat.title}
            href={`${localeLink}${cat.href}`}
            className="group flex items-center gap-4 rounded-2xl border border-base-line-primary p-6 backdrop-blur-sm transition-colors dark:border-transparent dark:bg-base-hover-fill-primary dark:hover:bg-base-fill-secondary pad:h-[90px] pad:px-6 pad:py-0"
          >
            <span className="flex-1 text-lg leading-[26px] text-base-label transition-colors group-hover:text-base-primary">
              {cat.title}
            </span>
            <ArrowIcon className="text-base-label-40 transition-colors group-hover:text-base-primary" />
          </a>
        ))}
      </div>
    </SectionContainer>
  );
}
